var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlane(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.964 9h4.02a2.5 2.5 0 000-5H5.102a1 1 0 01-.894-.553l-.448-.894A1 1 0 002.866 2H1a1 1 0 00-.92 1.394l2.143 5a1 1 0 00.92.606h3.863a1 1 0 01.928 1.371l-.901 2.259A1 1 0 007.96 14h2.042a1 1 0 00.78-.375l3.4-4.25a1 1 0 01.78-.375zm-6.98-6h4.75L10.784.4a1 1 0 00-.8-.4H8.102a1 1 0 00-.894 1.447L7.984 3z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default ForwardRef;